<template>
  <div class="l-task-list">
    <div class="task-item" v-for="(stage,sgIndex) in levels" :key="sgIndex">
      <!-- 阶段 -->
      <section class="stage">
        <div class="info">
          <h3 class="name">{{ stage.name }}</h3>
        </div>
        <!-- 关卡 -->
        <section class="level" v-for="(level,lIndex) in stage.datas" :key="lIndex">
          <div class="info">
            <h4 class="name">{{ level.name }}</h4>
            <span
              class="status"
              :class="[levelStatus(level)]"
            >{{ LEVEL_STATUS_LABEL[levelStatus(level)]}}</span>
          </div>
          <!-- 故事-->
          <ul class="store">
            <li v-for="(store,sIndex) in level.datas" :key="sIndex">
              <div class="info">
                <h5 class="name">{{ store.name }}</h5>
                <span class="attr"></span>
              </div>
              <template v-for="(temp) in store.datas">
                <!-- 情景段  -->
                <div class="chapter" v-if="temp.type===700" :key="temp.id">
                  <h5 class="name">{{ temp.name }}</h5>
                  <!-- 元素 -->
                  <Element v-for="(ele,eIndex) in temp.datas" :ele="ele" :key="eIndex" />
                </div>
                <!-- 元素 -->
                <Element v-else :ele="temp" :key="temp.id" />
              </template>
            </li>
          </ul>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import Element from './ele.vue'

export default {
  name: 'l-task',
  props: {
    levels: [Array],
  },
  components: { Element },
  data() {
    return {
      weekIdx: 0,
      weekId: '',
      isLastWeekId: 0,
      isNextWeekId: 0,
      levelData: {
        dans: [],
      },
      lessonType: '100', //   100：语课；101：阅课
      LEVEL_STATUS_LABEL: {
        done: '已通关',
        ing: '闯关ing',
      },
      LEVEL_STATUS: {
        done: 'done',
        ing: 'ing',
      },
    }
  },
  methods: {
    levelStatus(level) {
      if (level.done > 0) return this.LEVEL_STATUS.done
      else if (!level.done && !level.lock) return this.LEVEL_STATUS.ing
      else return ''
    },
    levelUpDown(item, idx) {
      this.levelData.dans.forEach((item, index) => {
        if (idx !== index) item['flag'] = false
      })
      this.levelData.dans[idx].flag = !item.flag
      this.levelData = Object.assign({}, this.levelData)
    },
    levelState(state) {
      if (state === 0) return 'icon-lily-suoding color1'
      else if (state === 1) return 'icon-lily-shouye color2'
      else if (state === 2) return 'icon-lily-duihao color3'
    },
  },
}
</script>

<style lang="stylus" scoped>
@import 'index.styl'
</style>
